<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.id">
                <div class="amphtml-layout-responsive">
                  <div class="amphtml-sizer"></div>
                  <iframe class="amphtml-fill-content" :src="src" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
                  <div class="iframe-overlay"></div>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">ここをクリックしてYoutube動画のIDを設定してください</span>
                </div>
              </template>
            </div>
          </section>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="動画のID" :label-width="labelWidth">
          <el-input v-model="contents.id" auto-complete="off"></el-input>
        </el-form-item>
        <div>
          <el-checkbox v-model="contents.fullWidth">最大幅で表示する</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="contents.related">動画が終わったら関連動画を表示する</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="contents.controls">プレーヤーのコントロールを表示する</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="contents.showinfo">動画のタイトルとプレーヤーの操作を表示する</el-checkbox>
        </div>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'youtube-1',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '120px'
    }
  },
  computed: {
    src: function () {
      return `https://www.youtube-nocookie.com/embed/${this.contents.id}?rel=${this.contents.rel ? 1 : 0}&controls=${this.contents.controls ? 1 : 0}&showinfo=${this.contents.showinfo ? 1 : 0}`
    }
  },
  methods: {
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <amp-youtube width="480" height="270" data-videoid="${contents.id}" layout="responsive" data-param-rel="${contents.rel ? 1 : 0}" data-param-controls="${contents.controls ? 1 : 0}" data-param-showinfo="${contents.showinfo ? 1 : 0}"></amp-youtube>
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    if (!this.posts.length) await this.$store.dispatch('wordpress/posts/fetch')

    // migration
    if (!this.contents.padding) this.contents.padding = {y: 0}
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './Youtube1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './Youtube1.s.scss';
}
.tablet,
.desktop {
  @import './Youtube1.m.scss';
}
.desktop {
  @import './Youtube1.l.scss';
}

.amphtml {
  &-layout-responsive {
    position: relative;
  }
  &-sizer {
    padding-top: (270 / 480 * 100%);
  }
  &-fill-content {
    display: block;
    margin: auto;
    width: 0;
    min-width: 100%;
    max-width: 100%;
    height: 0;
    min-height: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.iframe-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/contents/Youtube1/Youtube1.vue